import React from 'react'
import clsx from 'clsx'
import type { SpaceAllProps } from '../space/Space'
import Space from '../space/Space'
import withComponentMarkers from '../../shared/helpers/withComponentMarkers'

export type GridContainerColumns = number

export type GridContainerMedia = {
  small?: GridContainerColumns | false
  medium?: GridContainerColumns | false
  large?: GridContainerColumns | false
}

export type GridContainerProps = {
  columns?: GridContainerMedia | GridContainerColumns
  rowGap?: 'x-small' | 'small' | 'medium' | 'large' | boolean
  columnGap?: 'x-small' | 'small' | 'medium' | 'large' | boolean
}

export type GridContainerAllProps = GridContainerProps & SpaceAllProps

function GridContainer(props: GridContainerAllProps) {
  const {
    columns,
    rowGap,
    columnGap,
    style,
    className,
    children,
    element = 'div',
    ...rest
  } = props

  const styleObj = {
    ...compute(columns),
    ...style,
  }

  const n = 'dnb-grid-container'

  const unsetClasses = []
  for (const prop in styleObj) {
    if (styleObj[prop] === 'unset') {
      const disableClass = `${n}__disabled--${prop.replace(
        /--([a-z]+)-.*/,
        '$1'
      )}`
      unsetClasses.push(disableClass)
    }
  }

  const cn = clsx(
    n,
    className,
    columnGap &&
      `${n}--column-gap-${columnGap === true ? 'small' : columnGap}`,
    rowGap && `${n}--row-gap-${rowGap === true ? 'small' : rowGap}`,
    unsetClasses
  )

  return (
    <Space element={element} className={cn} style={styleObj} {...rest}>
      {children}
    </Space>
  )
}

withComponentMarkers(GridContainer, {
  _supportsSpacingProps: true,
})

export default GridContainer

function compute(columns) {
  if (!columns) {
    return null
  }

  const result = {}

  if (typeof columns === 'number') {
    columns = {
      small: columns,
      medium: columns,
      large: columns,
    }
  }

  for (const media in columns) {
    const value = columns?.[media]
    result[`--${media}-columns`] = value || 'unset'
  }

  return result
}
